import { initializeApp } from 'firebase/app';
import { getDatabase } from "firebase/database";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  updateProfile,
  updatePhoneNumber,
  signOut
} from 'firebase/auth';
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
  initializeFirestore,
  memoryLocalCache
} from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyAhnp2Yi7_y3UI2NacpYFP0TgeWO8b-8Is',
  authDomain: 'stk-merlin.firebaseapp.com',
  projectId: 'stk-merlin',
  storageBucket: 'stk-merlin.appspot.com',
  messagingSenderId: '410530544348',
  appId: '1:410530544348:web:9f0d8cf797f56bd4155219',
  measurementId: 'G-62LELZDDL6',
  databaseURL: "https://stk-merlin-default-rtdb.firebaseio.com/",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Initialize Firestore (New API) with an IN-MEMORY cache.
//
// We deliberately do NOT use a persistent (IndexedDB) cache. The persistent +
// multi-tab cache previously corrupted intermittently (firebase@9.23.0
// "INTERNAL ASSERTION FAILED" / "Failed to obtain primary lease"), which made
// batches vanish from the grid and forced a full browser cache clear to recover.
// An in-memory cache has no IndexedDB to corrupt, works in unlimited tabs, and
// always serves live data — the right trade-off for an always-online ops tool.
// (Any legacy poisoned IndexedDB left on disk is simply not read; it can be wiped
// via the "Reset local data" button — see config/firestoreRecovery.js.)
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true, // Force long polling to avoid QUIC errors
  localCache: memoryLocalCache()
});

const realtime = getDatabase(app);
const fileStorage = getStorage(app);
const functions = getFunctions(app);

// Old persistence code removed
/* 
enableMultiTabIndexedDbPersistence(db).catch(...)
*/

const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, 'users'), where('uid', '==', user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, 'users'), {
        uid: user.uid,
        name: user.displayName,
        authProvider: 'google',
        email: user.email
      });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, 'users'), {
      uid: user.uid,
      name,
      authProvider: 'local',
      email
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerSupplierWithEmailAndPassword = async (name, email, password, org) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, 'users'), {
      uid: user.uid,
      name,
      Organization: org,
      authProvider: 'local',
      email
    });
    return user;
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const sendPasswordReset = async email => {
  try {
    await sendPasswordResetEmail(auth, email);

  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

const updateUserPhoneNumber = async (phoneNumber) => {
  try {
    // await updatePhoneNumber()
  } catch (error) {
    console.log(error);
  }
};

export {
  auth,
  db,
  realtime,
  fileStorage,
  functions,
  signInWithGoogle,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  registerSupplierWithEmailAndPassword,
  sendPasswordReset,
  logout
};
